import { CodeDescription } from "./code-description-dto";

export class Gender {
    getGenderListing(): CodeDescription[] {
        return [
        { Code: 'F', Description: 'Female' },
        { Code: 'M', Description: 'Male' },
        { Code: 'U', Description: 'Unspecified' }
        ]
    }
}